import { Controller } from "stimulus"
import Honeybadger from "../honeybadger"

export default class TrackerController extends Controller {

  static get targets() {
    return ['trackable']
  }

  /**
   * 
   * @param {MouseEvent} event 
   * @returns void
   */
  track(event) {
    try {
      if (!event.target) return;
  
      const eventName = `link-click-${event.target.id ? event.target.id : 'unknown'}`
  
      
      if (window.isDevelopment) {
        console.log("DEV TRACK: ", eventName)
      } else {
        // production code
        if (!window.fathom) return;
        window.fathom.trackEvent(eventName)
      }

    } catch (ex) {
      Honeybadger.notify(ex)
    }
  }
  boundTrack = this.track.bind(this)


  initialize() {

    if (!window.fathom && !window.isDevelopment) {
      console.warn("TC cannot activate")
      return;
    }


    this.trackableTargets.forEach((target) => {
      console.log("tracking clicks for ", target.id)
      target.addEventListener('click', this.boundTrack)
    })
  }

}